import { render, staticRenderFns } from "./OrderContentType.vue?vue&type=template&id=f31b3fa2"
import script from "./OrderContentType.vue?vue&type=script&lang=js"
export * from "./OrderContentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports